(function() {
    'use strict';

    angular
        .module('app')
        .directive('keyboardSelection', keyboardSelection);

    keyboardSelection.$inject = ['$filter', '$timeout'];
    
    function keyboardSelection($filter, $timeout) {
        // Usage:
        //     <keyboardSelection></keyboardSelection>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                items: '=',
                showDropdown: '=',
                onSelectionChanged: '=',
                selectionMade: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.currentSelected = 0;

            var keyDown = function (event) {
                var selectItems = $(".select-item");
                if (scope.currentSelected == 0) {
                    $(element).scrollTop(0);
                }
                switch (event.keyCode) {
                    case 38:
                        if (scope.currentSelected > 0) {
                            scope.currentSelected = scope.currentSelected - 1;
                        }
                        if (scope.currentSelected > scope.items.length) {
                            scope.currentSelected = 0;
                        }
                        var iterations = 5;
                        if ($(selectItems[scope.currentSelected]).position().top < 44) {
                            while ($(selectItems[scope.currentSelected]).position().top < 44 && iterations > 0) {
                                $(element).scrollTop($(element).scrollTop() - 10);
                                iterations--;
                            }
                        }

                        scope.onSelectionChanged(scope.currentSelected);
                        break;
                    case 40:
                        if (scope.currentSelected > scope.items.length) {
                            scope.currentSelected = 0;
                        }
                        if (scope.currentSelected < scope.items.length) {
                            scope.currentSelected = scope.currentSelected + 1;
                        }
                        scope.onSelectionChanged(scope.currentSelected);
                        if ($(selectItems[scope.currentSelected]).position().top > 305) {
                            var iterations = 5;
                            while ($(selectItems[scope.currentSelected]).position().top > 305 && iterations > 0) {
                                $(element).scrollTop($(element).scrollTop() + 10);
                                iterations--;
                            }
                            
                        }
                        break;
                    case 13:
                        scope.selectionMade(scope.currentSelected);
                        break;
                }
                scope.$apply();
            }


            scope.$watch(function () {
                return scope.showDropdown;
            }, function (value) {
                if (value) {
                    $timeout(function () {
                        $('#searchfield').get(0).focus();
                    })
                    $(document).unbind("keydown");
                    $(document).bind("keydown", keyDown);
                    scope.currentSelected = 0;
                    scope.onSelectionChanged(scope.currentSelected);
                    $(element).scrollTop(0);
                    scope.$apply;
                    
                }
                else {
                    $(element).scrollTop(0);
                    $('#simplecriteria').get(0).focus();                  
                    $(document).unbind("keydown");
                }
            })
        }
    }

})();